import { GLOBAL_MK } from '@sm/Flags';
import { createRange } from '@utils';
import {
  SET_COMPARE_DATE_RANGE,
  SET_COMPARE_MODE,
  SET_DATE_RANGE,
  SET_MARKETPLACE,
  SET_SELECTED_MARKETPLACES,
  SET_SELECTED_SALES_CHANNELS
} from '../actions';
import { SET_PRODUCT_STATUS } from '../saga/products';
import { AMAZON_SALES_CHANNEL_ID, SHOPIFY_SALES_CHANNEL_ID } from '@sm/SalesChannels';

const initialState = {
  marketplaceID: null,
  dateRange: createRange(new Date(), new Date()),
  productStatus: 'active',
  compareDateRange: null,
  compareMode: 'Off',
  marketplaces: [],
  selectedMarketplaces: [GLOBAL_MK],
  selectedSalesChannels: [AMAZON_SALES_CHANNEL_ID, SHOPIFY_SALES_CHANNEL_ID]
};

export const selectorSelector = state => state.selector;

const selector = (state = initialState, action) => {
  switch (action.type) {
    case SET_MARKETPLACE: {
      const { marketplaceID } = action;
      return { ...state, marketplaceID };
    }
    case SET_SELECTED_MARKETPLACES: {
      return { ...state, selectedMarketplaces: action.payload };
    }
    case SET_DATE_RANGE: {
      const { dateRange } = action;
      return { ...state, dateRange };
    }
    case SET_COMPARE_DATE_RANGE: {
      const { compareDateRange } = action;
      return { ...state, compareDateRange };
    }
    case SET_COMPARE_MODE:
      return { ...state, compareMode: action.payload };
    case SET_PRODUCT_STATUS: {
      const { status } = action;
      return { ...state, productStatus: status };
    }
    case SET_SELECTED_SALES_CHANNELS: {
      return { ...state, selectedSalesChannels: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default selector;
